let map;

window.initMap = function () {
  const isMobile = window.innerWidth <= 767;
  const center = isMobile
    ? { lat: 39.2182922, lng: -99.335583 }
    : { lat: 37.0024137, lng: -95.4062429 };

  const map = new google.maps.Map(document.getElementById("map"), {
    zoom: 4,
    scrollwheel: false,
    center: center,
    mapTypeId: "roadmap",
  });

  const iconBase = MapSettings.awsUrl + "/branding/";
  const icon = iconBase + "decisely_torch.svg";

  MapSettings.locations.forEach((loc) => {
    const marker = new google.maps.Marker({
      position: { lat: loc.lat, lng: loc.lng },
      map,
      title: loc.title,
      icon,
    });

    const infoWindow = new google.maps.InfoWindow({
      content: loc.content,
    });

    marker.addListener("click", () => {
      infoWindow.open(map, marker);
    });
  });
};

// This ensures the map resizes correctly if needed
window.addEventListener("resize", () => {
  if (map) initMap();
});